/**
 * ShopuCart Location Intelligence System v5
 * ─────────────────────────────────────────
 * Uses Haversine distance from Sun City Arcade
 * to mirror exact Shopify shipping zones.
 *
 * Zones (from Sun City Arcade, F3-3, Kampala Road):
 *   0–7km    → Kampala Reliable   · UGX 5,000  · COD available
 *   7–14km   → Greater Kampala    · UGX 10,000 · COD available
 *   14–160km → Outside Kampala    · UGX 15,000 · Pay after seeing
 *   160km+   → Remote             · UGX 20,000 · Pay after seeing
 */

// ── SHOP LOCATION ─────────────────────────────────────────────
var SHOP = {
  lat: 0.3167,
  lng: 32.5822,
  name: 'Sun City Arcade, Kampala'
};

// ── DELIVERY ZONES (mirrors Shopify exactly) ──────────────────
var SC_ZONES = [
  {
    name: 'kampala_cbd',
    shopifyName: 'Kampala Reliable Delivery',
    minKm: 0,
    maxKm: 7,
    fee: 5000,
    feeName: 'UGX 5,000',
    time: 'Same day boda delivery',
    cod: true,
    icon: '🛵',
    message: '🛵 {city} — CBD delivery · COD ✓',
    badgeColor: '#1a1a1a',
    badgeBg: '#F7B210'
  },
  {
    name: 'greater_kampala',
    shopifyName: 'Greater Kampala & Nearby Areas',
    minKm: 7,
    maxKm: 14,
    fee: 10000,
    feeName: 'UGX 10,000',
    time: 'Same day delivery',
    cod: true,
    icon: '🚚',
    message: '🚚 {city} — Greater Kampala · COD ✓',
    badgeColor: '#1a1a1a',
    badgeBg: '#F7B210'
  },
  {
    name: 'outside_kampala',
    shopifyName: 'Outside Kampala',
    minKm: 14,
    maxKm: 160,
    fee: 15000,
    feeName: 'UGX 15,000',
    time: '1-2 days courier delivery',
    cod: false,
    icon: '📦',
    message: '📦 {city} — Courier delivery · Pay after seeing',
    badgeColor: '#1a1a1a',
    badgeBg: '#F7B210'
  },
  {
    name: 'remote',
    shopifyName: 'Outside Kampala',
    minKm: 160,
    maxKm: 99999,
    fee: 20000,
    feeName: 'UGX 20,000',
    time: '2-3 days delivery',
    cod: false,
    icon: '📹',
    message: '📹 {city} — Video Verification required',
    badgeColor: '#1a1a1a',
    badgeBg: '#F7B210'
  }
];

// ── HAVERSINE DISTANCE ────────────────────────────────────────
// Returns distance in km between two lat/lng points
function haversine(lat1, lng1, lat2, lng2) {
  var R = 6371; // Earth radius in km
  var dLat = (lat2 - lat1) * Math.PI / 180;
  var dLng = (lng2 - lng1) * Math.PI / 180;
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// ── GET ZONE FROM DISTANCE ────────────────────────────────────
function getZoneByDistance(km) {
  for (var i = 0; i < SC_ZONES.length; i++) {
    if (km >= SC_ZONES[i].minKm && km < SC_ZONES[i].maxKm) {
      return SC_ZONES[i];
    }
  }
  return SC_ZONES[SC_ZONES.length - 1];
}

// ── COOKIE HELPERS ────────────────────────────────────────────
function setCookie(name, value, days) {
  var expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
}

function getCookie(name) {
  return document.cookie.split('; ').reduce(function(r, v) {
    var parts = v.split('=');
    return parts[0] === name ? decodeURIComponent(parts[1]) : r;
  }, null);
}

// ── EXTRACT CITY ──────────────────────────────────────────────
function extractCity(locationString) {
  if (!locationString) return locationString;
  return locationString.split(',')[0].trim();
}

// ── ADJUST LAYOUT FOR BANNER ──────────────────────────────────
function adjustLayout(height) {
  // Expose the banner height as a CSS variable so any sticky element
  // on the site (category chips, filters bars, sidebars, etc.) can
  // offset itself with calc(var(--sc-banner-height, 0px) + Npx)
  // instead of needing its own JS wiring.
  document.documentElement.style.setProperty('--sc-banner-height', height + 'px');

  document.body.style.paddingTop = height + 'px';
  document.body.style.marginTop = '0px';

  document.querySelectorAll('[class*="ai-amazon-header-"]').forEach(function(el) {
    el.style.top = height + 'px';
  });
}

// ── SHOW BANNER ───────────────────────────────────────────────
function showBanner(city, zone, distanceKm) {
  var existing = document.getElementById('sc-delivery-banner');
  if (existing) existing.remove();

  var message = zone.message.replace('{city}', city);
  var distanceText = distanceKm ? ' (' + Math.round(distanceKm) + 'km from Kampala)' : '';

  var banner = document.createElement('div');
  banner.id = 'sc-delivery-banner';
  banner.setAttribute('data-zone', zone.name);
  banner.setAttribute('data-cod', zone.cod ? 'true' : 'false');
  banner.style.cssText = [
    'width:100%',
    'background-color:' + zone.badgeBg,
    'color:' + zone.badgeColor,
    'text-align:center',
    'padding:6px 36px 6px 8px',
    'font-size:12px',
    'font-weight:600',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'gap:4px',
    'flex-wrap:nowrap',
    'white-space:nowrap',
    'overflow:hidden',
    'position:fixed',
    'top:0',
    'left:0',
    'right:0',
    'z-index:10000001',
    'box-sizing:border-box',
    'border-bottom:1px solid ' + zone.badgeColor + '44'
  ].join(';');

  banner.innerHTML =
    '<span style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + message + '</span>' +
    '<span style="flex-shrink:0;margin-left:4px;font-size:11px;opacity:0.7;font-weight:400;white-space:nowrap;">' + zone.feeName + '</span>' +
    '<button id="sc-banner-close" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);background:transparent;border:none;color:' + zone.badgeColor + ';cursor:pointer;font-size:16px;padding:0;line-height:1;flex-shrink:0;">&#x2715;</button>';

  document.body.prepend(banner);

  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      var height = banner.offsetHeight || 38;
      adjustLayout(height);
      var closeBtn = document.getElementById('sc-banner-close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          banner.remove();
          adjustLayout(0);
        });
      }
    });
  });
}

// ── UPDATE TRENDING CITY ──────────────────────────────────────
function updateTrending(city) {
  var newTitle = 'Trending in ' + city;

  // Method 1: data-trending-title
  var targets = document.querySelectorAll('[data-trending-title]');

  // Method 2: fallback class search
  if (targets.length === 0) {
    targets = document.querySelectorAll('[class*="flash-deals-animated-text"]');
  }

  targets.forEach(function(container) {
    var text = container.textContent.trim().toLowerCase();
    if (container.hasAttribute('data-trending-title') || text.includes('trending in')) {
      var existingSpan = container.querySelector('span');
      if (!existingSpan) return;
      var letterClass = existingSpan.className;
      var html = '';
      for (var i = 0; i < newTitle.length; i++) {
        var char = newTitle[i];
        html += char === ' '
          ? '<span class="' + letterClass + '">&nbsp;</span>'
          : '<span class="' + letterClass + '">' + char + '</span>';
      }
      container.innerHTML = html;
    }
  });

  document.querySelectorAll('[data-trending-city]').forEach(function(el) {
    el.textContent = city;
  });
}

// ── SYNC TO SHOPIFY CART ──────────────────────────────────────
function syncToCart(city, zone, distanceKm, lat, lng) {
  var attributes = {
    'delivery_city': city,
    'delivery_zone': zone.shopifyName,
    'delivery_fee': zone.feeName,
    'delivery_time': zone.time,
    'delivery_cod': zone.cod ? 'yes' : 'no',
    'delivery_distance_km': distanceKm ? Math.round(distanceKm).toString() : ''
  };

  // Store coordinates for potential checkout use
  if (lat && lng) {
    attributes['delivery_lat'] = lat.toString();
    attributes['delivery_lng'] = lng.toString();
  }

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: attributes })
  }).catch(function() {});
}

// ── PREFILL CHECKOUT ──────────────────────────────────────────
function prefillCheckout(city) {
  var cityField = document.querySelector('#checkout_shipping_address_city');
  if (cityField && cityField.value === '') {
    cityField.value = city;
    cityField.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// ── VPN / ABROAD VISITORS ─────────────────────────────────────
// Facebook is blocked in Uganda, so most ad visitors browse through a VPN
// and IP detection places them abroad (Brussels, Atlanta, London...).
// Anyone detected outside Uganda gets a general delivery notice instead of
// the "remote / video verification / no COD" zone.
var SC_VPN_KM = 800;
var SC_VPN_ZONE = {
  name: 'vpn_unknown',
  message: '📍 We deliver across Uganda · Kampala same day · Pay on delivery available',
  feeName: '',
  badgeColor: '#1a1a1a',
  badgeBg: '#F7B210',
  cod: true
};

function showVpnNotice() {
  showBanner('', SC_VPN_ZONE, null);
}

function handleVpn(locationString) {
  // Clear any foreign location saved earlier
  ['sc_location', 'sc_city', 'sc_zone', 'sc_cod', 'sc_lat', 'sc_lng'].forEach(function(name) {
    setCookie(name, '', -1);
  });
  try { localStorage.removeItem('deliveryLocation'); } catch (e) {}
  setCookie('sc_vpn', '1', 1);

  // Tag the order so the town gets confirmed by phone
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: {
      delivery_city: '',
      delivery_zone: 'Not detected (VPN or abroad)',
      delivery_fee: '',
      delivery_time: '',
      delivery_cod: '',
      delivery_distance_km: '',
      delivery_lat: '',
      delivery_lng: '',
      delivery_detected_location: locationString || ''
    } })
  }).catch(function() {});

  showVpnNotice();
  console.log('[ShopuCart] ' + locationString + ' is outside Uganda — treating as VPN, showing general Uganda delivery notice');
}

// ── APPLY EVERYTHING ──────────────────────────────────────────
function applyLocation(locationString, lat, lng) {
  if (!locationString) return;

  // VPN / abroad visitor — don't apply a delivery zone
  if (lat && lng && haversine(lat, lng, SHOP.lat, SHOP.lng) > SC_VPN_KM) {
    handleVpn(locationString);
    return;
  }

  var city = extractCity(locationString);

  // Calculate distance from Sun City Arcade
  var distanceKm = null;
  var zone;

  if (lat && lng) {
    distanceKm = haversine(lat, lng, SHOP.lat, SHOP.lng);
    zone = getZoneByDistance(distanceKm);
    console.log('[ShopuCart] ' + city + ' is ' + Math.round(distanceKm) + 'km from Sun City Arcade → Zone: ' + zone.shopifyName);
  } else {
    // No coordinates — use default outside kampala
    zone = SC_ZONES[2];
    console.log('[ShopuCart] No coordinates for ' + city + ' — defaulting to Outside Kampala');
  }

  // Save everything
  setCookie('sc_location', locationString, 30);
  setCookie('sc_city', city, 30);
  setCookie('sc_zone', zone.name, 30);
  setCookie('sc_cod', zone.cod ? 'yes' : 'no', 30);
  if (lat && lng) {
    setCookie('sc_lat', lat.toString(), 30);
    setCookie('sc_lng', lng.toString(), 30);
  }
  window.SC._originalSetItem('deliveryLocation', locationString);

  // Apply all updates
  syncToCart(city, zone, distanceKm, lat, lng);
  showBanner(city, zone, distanceKm);
  updateTrending(city);
  prefillCheckout(city);

  // Store globally for console access
  window.SC.currentCity = city;
  window.SC.currentZone = zone;
  window.SC.currentDistance = distanceKm;

  document.dispatchEvent(new CustomEvent('sc:locationUpdated', {
    detail: { city: city, zone: zone, distanceKm: distanceKm, cod: zone.cod }
  }));
}

// ── IP GEOLOCATION ────────────────────────────────────────────
// Tries ipapi.co first (as before); if it is blocked (it often hits its
// free daily limit) falls back to ipwho.is, then geojs.io. Each returns city, country and
// coordinates; if all fail, the general Uganda delivery notice is shown.
var SC_IP_SERVICES = [
  { url: 'https://ipapi.co/json/', read: function(d) {
    return d.error ? null : { city: d.city, country: d.country_name, lat: d.latitude, lng: d.longitude };
  } },
  { url: 'https://ipwho.is/', read: function(d) {
    return d.success === false ? null : { city: d.city, country: d.country, lat: d.latitude, lng: d.longitude };
  } },
  { url: 'https://get.geojs.io/v1/ip/geo.json', read: function(d) {
    return { city: d.city, country: d.country, lat: d.latitude, lng: d.longitude };
  } }
];

function detectFromIP(callback, onFail) {
  var i = 0;
  function next() {
    if (i >= SC_IP_SERVICES.length) {
      if (onFail) onFail();
      return;
    }
    var service = SC_IP_SERVICES[i++];
    fetch(service.url)
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data) {
        var loc = data && service.read(data);
        if (loc && loc.city && loc.lat && loc.lng) {
          callback(
            loc.city + ', ' + (loc.country || 'Uganda'),
            parseFloat(loc.lat),
            parseFloat(loc.lng)
          );
        } else {
          next();
        }
      })
      .catch(next);
  }
  next();
}

// ── GLOBAL SC OBJECT ──────────────────────────────────────────
window.SC = {
  _originalSetItem: localStorage.setItem.bind(localStorage),
  currentCity: null,
  currentZone: null,
  currentDistance: null,

  // Public: manually apply a location (for console testing)
  apply: function(locationString, lat, lng) {
    if (lat && lng) {
      applyLocation(locationString, lat, lng);
    } else {
      // Geocode via nominatim
      var city = extractCity(locationString);
      fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(city + ' Uganda') + '&limit=1')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data && data[0]) {
            applyLocation(locationString, parseFloat(data[0].lat), parseFloat(data[0].lon));
          } else {
            applyLocation(locationString, null, null);
          }
        })
        .catch(function() { applyLocation(locationString, null, null); });
    }
  },

  // Public: get current zone info
  info: function() {
    console.log('City:', window.SC.currentCity);
    console.log('Zone:', window.SC.currentZone ? window.SC.currentZone.shopifyName : 'unknown');
    console.log('Distance:', window.SC.currentDistance ? Math.round(window.SC.currentDistance) + 'km' : 'unknown');
    console.log('COD:', window.SC.currentZone ? window.SC.currentZone.cod : 'unknown');
  },

  getCookie: getCookie,
  setCookie: setCookie,
  haversine: haversine
};

// ── HOOK INTO HEADER SAVE ─────────────────────────────────────
localStorage.setItem = function(key, value) {
  window.SC._originalSetItem(key, value);
  if (key === 'deliveryLocation') {
    // When header saves location, geocode it to get coordinates
    window.SC.apply(value);
  }
};

// ── INIT ──────────────────────────────────────────────────────
function init() {
  var savedLocation = getCookie('sc_location') || localStorage.getItem('deliveryLocation');
  var savedLat = getCookie('sc_lat');
  var savedLng = getCookie('sc_lng');

  if (savedLocation && savedLat && savedLng) {
    // Returning visitor with saved coordinates — fastest path
    applyLocation(savedLocation, parseFloat(savedLat), parseFloat(savedLng));
  } else if (savedLocation) {
    // Returning visitor without coordinates — geocode
    window.SC.apply(savedLocation);
  } else if (getCookie('sc_vpn')) {
    // Detected as VPN within the last day — skip the IP lookup
    showVpnNotice();
  } else {
    // New visitor — IP detection with coordinates
    if (window.SC._detecting) return;
    window.SC._detecting = true;
    detectFromIP(function(locationString, lat, lng) {
      applyLocation(locationString, lat, lng);
    }, function() {
      // All lookups failed — still show the general delivery notice
      showVpnNotice();
    });
  }
}

// Run on load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Fallback on full page load
window.addEventListener('load', function() {
  var banner = document.getElementById('sc-delivery-banner');
  if (!banner) {
    init();
  } else {
    requestAnimationFrame(function() {
      adjustLayout(banner.offsetHeight || 38);
    });
  }
});
